'use client';
import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Topbar from './Topbar';

interface AppLayoutProps {
  children: React.ReactNode;
  role?: 'student' | 'parent' | 'professional' | 'admin';
  campusMode?: 'kid' | 'teen' | 'pro';
}

export default function AppLayout({
  children,
  role = 'student',
  campusMode = 'pro',
}: AppLayoutProps) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      {/* Mobile overlay */}
      {mobileSidebarOpen && (
        <div
          className="fixed inset-0 z-30 bg-foreground/20 backdrop-blur-sm lg:hidden"
          onClick={() => setMobileSidebarOpen(false)}
        />
      )}

      <Sidebar
        collapsed={sidebarCollapsed}
        mobileOpen={mobileSidebarOpen}
        role={role}
        onClose={() => setMobileSidebarOpen(false)}
      />

      <div className="flex flex-col flex-1 overflow-hidden">
        <Topbar
          onToggleSidebar={() => setSidebarCollapsed((p) => !p)}
          onMobileMenu={() => setMobileSidebarOpen((p) => !p)}
          role={role}
          campusMode={campusMode}
        />
        <main className="flex-1 overflow-y-auto">
          <div className="max-w-screen-2xl mx-auto px-6 lg:px-8 xl:px-10 2xl:px-16 py-6">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
}